// Admin's own tasting scores. Keys are stored as-is in Beer.ratings; 0 means
// "not rated" and is simply not shown.
export const RATINGS: [string, string][] = [
  ['carbonation', 'Carbonation'],
  ['appearance', 'Appearance'],
  ['aroma', 'Aroma'],
  ['taste', 'Taste'],
];

const STARS = [5, 4, 3, 2, 1];

// The trailing "×" is a real radio with value 0: it makes the group always
// submit something (so a cleared score overwrites the old one) and is how a
// category goes back to unrated — a checked star cannot be unchecked.
export function renderRatingInputs(ratings: Record<string, number> = {}): string {
  return `<div class="rating-inputs">${RATINGS.map(
    ([key, label]) => `
      <div class="rating-row">
        <span class="rating-label">${label}</span>
        <span class="stars-input">${STARS.map(
          (n) => `<label><input type="radio" name="rating_${key}" value="${n}"${
            ratings[key] === n ? ' checked' : ''
          }><span>★</span></label>`
        ).join('')}<label class="star-clear" title="Not rated"><input type="radio" name="rating_${key}" value="0"${
          ratings[key] ? '' : ' checked'
        }><span>×</span></label></span>
      </div>`
  ).join('')}</div>`;
}

export function renderRatingView(beer: { ratings: Record<string, number>; tasting_notes: string }): string {
  const rows = RATINGS.filter(([key]) => beer.ratings?.[key] > 0).map(
    ([key, label]) => `
      <div class="rating-row">
        <span class="rating-label">${label}</span>
        <span class="stars">${'★'.repeat(beer.ratings[key])}<span class="stars-off">${'★'.repeat(
          5 - beer.ratings[key]
        )}</span></span>
      </div>`
  );
  if (!rows.length && !beer.tasting_notes) return '';
  return `
    <div class="beer-rating">
      <h4 class="detail-heading">Tasting notes</h4>
      ${rows.join('')}
      ${beer.tasting_notes ? `<p class="rating-notes">${beer.tasting_notes}</p>` : ''}
    </div>`;
}
